export default __webpack_public_path__ + "static/media/BLR18.e9c0e543.jpg";